export default __webpack_public_path__ + "static/media/rating.4d7c061b.svg";